<template>
  <button
    class="flex items-center justify-center p-2 rounded-full hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors"
    :title="isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'"
    @click="toggleDarkMode"
  >
    <Icon
      :path="isDarkMode ? mdiWeatherSunny : mdiWeatherNight"
      class="h-5 w-5 text-gray-700 dark:text-gray-200"
    />
  </button>
</template>

<script>
import { mdiWeatherNight, mdiWeatherSunny } from "@mdi/js";

export default {
  name: "DarkModeToggle",
  data() {
    return {
      mdiWeatherNight,
      mdiWeatherSunny,
    };
  },
  computed: {
    isDarkMode() {
      return this.$store.state.darkMode;
    },
  },
  methods: {
    toggleDarkMode() {
      this.$store.dispatch("toggleDarkMode");
    },
  },
};
</script>
